import Navbar from '@/components/landing/Navbar'
import DocumentationIntro from './DocumentationIntro'
import FeatureGridSection from './FeatureGridSection'
import GetStartedSection from './GetStartedSection'
import UseCasesSection from './UseCasesSection'
import CommonMistakesSection from './CommonMistakesSection'
import { FaqSection, FinalCta } from '@/components/landing'

export default function DocumentationScreen() {
  return (
    <div>
      <Navbar />

      <DocumentationIntro />

      <FeatureGridSection />

      <GetStartedSection />

      <UseCasesSection />

      <CommonMistakesSection />

      <FaqSection />

      <FinalCta />
    </div>
  )
}
